import React from 'react';
// Components
import { PillLabel } from '../../misc';
// Utils
import { PILL_COLORS } from '@/utils/colors';
import { formatMessage } from '@/utils/i18n';

interface SharedToPillLabelProps {
  flags?: string[];
}

const FLAG_CONFIG: Record<string, { key: string; color: PILL_COLORS }> = {
  SharedWithClient: {
    key: 'ComparisonsTableV2.Flags.SharedWithClient',
    color: PILL_COLORS.GREEN,
  },
};

const SharedToPillLabel: React.FC<SharedToPillLabelProps> = ({ flags }) => {
  if (flags && flags.length > 0) {
    return (
      <div>
        {flags.map((flag, index) => {
          const config = FLAG_CONFIG[flag];

          return (
            <PillLabel
              key={index}
              icon="ds-account-checked"
              className="pill-label-v2"
              color={config?.color ?? PILL_COLORS.GREEN}
              text={formatMessage(config?.key ?? flag)}
            />
          );
        })}
      </div>
    );
  }

  return <></>;
};

export default SharedToPillLabel;
